module.exports = __webpack_public_path__ + "img/machanic.84cbfb30.jpg";